//change this farm address to your address
export const farmAddress = "B1NbSUSmSxqbrqbnafQgR1pnKc3skuBcuiZP9FB4JhY8"

//might want to consider using your own RPC node
export const rpc = "https://multi-indulgent-diagram.solana-mainnet.quiknode.pro/f85f6b7ae83a036c1eaa687949e48d39de3f7baa/"

//change to "Mainnet" when ready to deploy
export const server = "Mainnet"

//do not change this!! if the claim button is consistently having issues displaying the correct amount, then I recommend changing this back to "true", which is the way Gem Farm intended for their system to work
export const showRefreshButton = false
